export const logPageViewEvent = (page, logged_in_oem_id) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', page, {
      event_category: 'pageload',
      url: window.location.href,
      oem_id: logged_in_oem_id
    });
  }
};
